import { Grid, Paper } from "@mui/material";
import InventoryTable from "./Desktop/InventoryTable";
import { FC, useState } from "react";
import { useInventory } from "../../InventoryProvider";
import { getSelectedRows } from "../../../../helpers/utils";
import InventoryPhoneData from "./Phone/InventoryPhoneData";
import QrScannerFind from "../popups/QrScannerFind";
import ToolbarDesktop from "./Desktop/ToolbarDesktop";
import ToolbarPhone from "./Phone/ToolbarPhone";

type InventoryTableContainerTypes = {
  popupToggles: {
    history: boolean;
    addProduct: boolean;
    batchEdit: boolean;
    ganttChart: boolean;
    batchQrScannerToggle: boolean;
    batchEditMode: boolean;
  };
  setPopupToggles: React.Dispatch<
    React.SetStateAction<{
      history: boolean;
      addProduct: boolean;
      batchEdit: boolean;
      ganttChart: boolean;
      batchQrScannerToggle: boolean;
      batchEditMode: boolean;
    }>
  >;
};

const InventoryTableContainer: FC<InventoryTableContainerTypes> = ({
  popupToggles,
  setPopupToggles,
}) => {
  const [qrScannerToggle, setQrScannerToggle] = useState<boolean>(false);

  const {
    rows,
    filteredRows,
    setFilteredRows,
    isPhoneSize,
    setSelectedProduct,
  } = useInventory();

  const handleFilterChangeQrScan = (
    listOfScannedQr: string[],
    QrValueJustScanned: string
  ) => {
    setQrScannerToggle(false);
    const row = rows.find((r) => r.serial == QrValueJustScanned);
    console.log(row);
    if (row) setSelectedProduct(row);
  };

  const selectedRows = getSelectedRows(filteredRows);

  return (
    <>
      {qrScannerToggle && (
        <QrScannerFind
          onScannedListChange={handleFilterChangeQrScan}
          qrScannerToggle={qrScannerToggle}
          setQrScannerToggleFalse={() => setQrScannerToggle(false)}
        />
      )}

      <Paper
        sx={{
          borderRadius: 2,
          padding: isPhoneSize ? 0 : 2,
          marginBottom: { xs: 12, sm: 0 },
        }}
      >
        <Grid container flexDirection={"column"} gap={1}>
          {isPhoneSize ? (
            <ToolbarPhone
              popupToggles={popupToggles}
              setPopupToggles={setPopupToggles}
              setQrScannerToggle={setQrScannerToggle}
              selectedRows={selectedRows}
            />
          ) : (
            <ToolbarDesktop
              popupToggles={popupToggles}
              setPopupToggles={setPopupToggles}
              selectedRows={selectedRows}
            />
          )}

          {rows.length > 0 &&
            (isPhoneSize ? (
              <InventoryPhoneData />
            ) : (
              <InventoryTable batchEditMode={popupToggles.batchEditMode} />
            ))}
        </Grid>
      </Paper>
    </>
  );
};

export default InventoryTableContainer;
